import React from 'react'
import { Link } from 'react-router-dom'
import ApiUrl from '../../../../configTools/apiUrl'

const UserGrid3 = ({Users,Columns}) => {
  return (
    <div className='public_home_user_grid_container'>
      <div className='public_home_user_grid_users' style={{
        flexWrap:"wrap"
      }}>
        {
            Users.map((user,index)=>{
                return(
                    <div style={{width:String(95/(parseInt(Columns)))+"%", position:"relative",paddingBottom:"30px"}} key={index}>
                        <div>
                            <Link to={'/user/'+user.username}>
                                <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+user.image})`,borderRadius:'10px', overflow:'hidden'}}>
                                    <div className='public_home_product_grid_1_products_item_overlay'></div>
                                </div>
                            </Link>
                            <div className='public_home_product_grid_1_products_item_title'>
                                <Link to={'/user/'+user.username}><h5>{user.firstname} {user.lastname}</h5></Link>
                            </div>
                        </div>
                    </div>
                )
            })
        }
      </div>
    </div>
  )
}

export default UserGrid3
